import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import TrustedBy from "@/components/sections/TrustedBy";
import Services from "@/components/sections/Services";
import Industries from "@/components/sections/Industries";
import AIAgents from "@/components/sections/AIAgents";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import TechStack from "@/components/sections/TechStack";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/widgets/FloatingWhatsApp";
import ChatbotWidget from "@/components/widgets/ChatbotWidget";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#0B0F19] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustedBy />
      <Services />
      <Industries />
      <AIAgents />
      <WhyChooseUs />
      <TechStack />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
      <ChatbotWidget />
    </main>
  );
}
